import { Injectable } from '@angular/core';
import { CameraLayers } from '../enum/CameraLayers';
import { Subject } from 'rxjs/Subject';

declare let THREE: any;

@Injectable()
export class CameraService {

  orto;
  perspective;
  camera;
  w = window.innerWidth - 335;
  h = window.innerHeight - 7;
  cameraTrackerSubj = new Subject<any>();

  constructor() {
    this.orto = new THREE.OrthographicCamera(-this.w / 2, this.w / 2, this.h / 2, -this.h / 2, -1000, 1000);
    this.orto.updateMatrixWorld();

    this.orto.rotateX(-Math.PI / 2);
    this.orto.layers.enable(2);
    this.orto.layers.enable(3);
    this.orto.layers.enable(6);
    this.orto.layers.enable(CameraLayers.HORIZONTAL_RESIZE);
    this.orto.layers.enable(CameraLayers.SPRITE_2D);
    this.orto.position.y = 500;

    // this.camera = this.orto;
    this.switchTo2D();

    this.perspective = new THREE.PerspectiveCamera(45, this.w / this.h, 1, 10000);
    this.perspective.position.set(0, 500, 1000);
    // this.perspective.rotateX(-Math.PI / 4);
    // this.perspective.rotation.y = Math.PI/4;
    this.perspective.layers.enable(2);
    this.perspective.layers.enable(4);
    this.perspective.layers.enable(5);
    this.perspective.layers.enable(CameraLayers.HORIZONTAL_RESIZE);
    this.perspective.layers.enable(CameraLayers.VERTICAL_RESIZE);

    (window as any).cam = this;
  }

  switchTo2D() {
    // console.log(this.orto);
    // console.log('window.innerWidth', window.innerWidth);
    this.camera = this.orto;
    this.cameraTrackerSubj.next(false);
  }

  switchTo3D() {
    this.camera = this.perspective;
    this.cameraTrackerSubj.next(true);
  }

  getCamera() {
    return this.camera;
  }

  isIn2D() {
    return this.camera instanceof THREE.OrthographicCamera;
  }

  isIn3D() {
    return this.camera instanceof THREE.PerspectiveCamera;
  }

  resize(w: number, h: number) {
    this.perspective.aspect = w / h;
    this.perspective.updateProjectionMatrix();

    this.orto.left = -w / 2;
    this.orto.right = w / 2;
    this.orto.top = h / 2;
    this.orto.bottom = -h / 2;
    this.orto.updateProjectionMatrix();
  }

  reset() {
    const camera = this.getCamera();
    if (this.isIn2D()) {
      camera.position.set(0, 500, 0);
    } else {
      camera.position.set(0, 500, 1000);
      camera.rotation.set(Math.PI / 2, 0, 0);
    }
  }

  getPerspective() {
    return this.perspective;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/camera.service.ts